import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/molecules/dialog";
import {
  RTE_MARKDOWN_DIALOG_TITLE,
  RTE_MARKDOWN_DIALOG_DESCRIPTION,
} from "@/constants/uiCopy/richTextEditor";
import {
  CONSOLE_DIALOG_BODY_CLASS,
  CONSOLE_DIALOG_TITLE_CLASS,
} from "@/lib/ui/consoleDialogTypography";
import { cn } from "@/lib/utils";

export interface MarkdownHelpModalProps {
  children: ReactNode;
}

const markdownTips: { label: string; content: ReactNode }[] = [
  { label: "Bold:", content: <code>**text**</code> },
  { label: "Italic:", content: <code>*text*</code> },
  { label: "Strong (screen readers):", content: <code>__text__</code> },
  { label: "Emphasized (screen readers):", content: <code>_text_</code> },
  { label: "Bullet list:", content: <code>- item</code> },
  { label: "Numbered list:", content: <code>1. item</code> },
  {
    label: "Apostrophe:",
    content: (
      <>
        <code>’</code> or toolbar
      </>
    ),
  },
  {
    label: "Variables:",
    content: (
      <>
        <code>{`{{name}}`}</code> or <code>{`{{@directive/var}}`}</code>
      </>
    ),
  },
  { label: "Horizontal rule:", content: <code>---</code> },
];

export const MarkdownHelpModal = ({ children }: MarkdownHelpModalProps) => (
  <Dialog>
    <DialogTrigger asChild>{children}</DialogTrigger>
    <DialogContent surface="console">
      <DialogHeader>
        <DialogTitle className={CONSOLE_DIALOG_TITLE_CLASS}>
          {RTE_MARKDOWN_DIALOG_TITLE}
        </DialogTitle>
        <DialogDescription
          id="rte-markdown-desc"
          className={CONSOLE_DIALOG_BODY_CLASS}
        >
          {RTE_MARKDOWN_DIALOG_DESCRIPTION}
        </DialogDescription>
      </DialogHeader>
      <div
        className={cn(
          CONSOLE_DIALOG_BODY_CLASS,
          "space-y-3 text-foreground/80",
        )}
      >
        {markdownTips.map((row) => (
          <p key={row.label}>
            <strong>{row.label}</strong> {row.content}
          </p>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
